// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setActiveCompany,
  toggleAddEditModal,
  setEditableCompany,
  setCompanyUsers,
  setCompanyDivision,
  setEditableUser,
  setCompanyLanguages,
  setUserRolePermissions,
  clearCompanyAdministrating,
  setCompanyModalLoading,
  setUserEditRoles,
  setCaseManagersByDivision,
  setCompanyCaseManegers,
  setCompanyGenders,
  setCompanyUserModalClinicians,
  resetCompany,
  setAdminBillingPrograms,
  setCompanyDivisionByCompany,
  setCompanyGoalCategories,
  setCompanyGoals,
  setRpmCompanyGoals
} from 'src/store/modules/companiesAdministrating'

const initialState = {
  companiesList: [],
  activeCompany: {},
  isAddEditModalOpen: false,
  editableCompany: {},
  companyUsers: [],
  companyDivision: [],
  companyDivisionByCompany: [],
  editableUser: {},
  companyLanguages: [],
  userRolePermissions: {},
  companyLicensesList: [],
  licensesList: [],
  companyModalLoading: false,
  userRoles: [],
  caseManagersByDivision: [],
  companyCaseManagers: [],
  companyUserModalClinicians: [],
  adminBillingPrograms: []
}

export default handleActions(
  {
    [setActiveCompany](state, { payload: activeCompany }) {
      return {
        ...state,
        activeCompany
      }
    },
    [toggleAddEditModal](state, { payload: isAddEditModalOpen }) {
      return {
        ...state,
        isAddEditModalOpen
      }
    },
    [setEditableCompany](state, { payload: editableCompany }) {
      return {
        ...state,
        editableCompany
      }
    },
    [setCompanyDivision](state, { payload: companyDivision }) {
      return {
        ...state,
        companyDivision
      }
    },
    [setCompanyDivisionByCompany](
      state,
      { payload: companyDivisionByCompany }
    ) {
      return {
        ...state,
        companyDivisionByCompany
      }
    },
    [setCompanyUsers](state, { payload: companyUsers }) {
      return {
        ...state,
        companyUsers
      }
    },
    [setEditableUser](state, { payload: editableUser }) {
      return {
        ...state,
        editableUser
      }
    },
    [setCompanyLanguages](state, { payload: companyLanguages }) {
      return {
        ...state,
        companyLanguages
      }
    },
    [setUserRolePermissions](state, { payload: userRolePermissions }) {
      return {
        ...state,
        userRolePermissions
      }
    },
    [setCompanyModalLoading](state, { payload: companyModalLoading }) {
      return {
        ...state,
        companyModalLoading
      }
    },
    [clearCompanyAdministrating]() {
      return {
        ...initialState
      }
    },
    [setUserEditRoles](state, { payload: userRoles }) {
      return {
        ...state,
        userRoles
      }
    },
    [setCaseManagersByDivision](state, { payload: caseManagersByDivision }) {
      return {
        ...state,
        caseManagersByDivision
      }
    },
    [setCompanyCaseManegers](state, { payload: companyCaseManagers }) {
      return {
        state,
        ...companyCaseManagers
      }
    },
    [setCompanyGenders](state, { payload: companyGendersList }) {
      return {
        ...state,
        companyGendersList
      }
    },
    [setCompanyUserModalClinicians](
      state,
      { payload: companyUserModalClinicians }
    ) {
      return {
        ...state,
        companyUserModalClinicians
      }
    },
    [setAdminBillingPrograms](state, { payload: adminBillingPrograms }) {
      return {
        ...state,
        adminBillingPrograms
      }
    },
    [resetCompany]() {
      return initialState
    },
    [setCompanyGoalCategories](state, { payload: companyGoalCategories }) {
      return {
        ...state,
        companyGoalCategories
      }
    },
    [setCompanyGoals](state, { payload: companyGoals }) {
      return {
        ...state,
        companyGoals
      }
    },
    [setRpmCompanyGoals](state, { payload: rpmCompanyGoals }) {
      return {
        ...state,
        rpmCompanyGoals
      }
    }
  },
  initialState
)
